import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectIsRecommendedPackagePaymentStatusCheckInProgress,
  selectPackagePayment,
} from '../../../../../../../reducers/v2/paymentProcessing/selectors';
import { selectIsMobileLayout } from '../../../../../../../selectors/layout';
import { checkPaymentStatus } from '../../../../../../../thunks/payment/checkPaymentStatus';
import { defaultTo } from 'lodash';
import {
  processChangingCheckPaymentStatus,
  EPaymentStatusCheckType,
} from '../../../../../../../thunks/payment/processChangingCheckPaymentStatus';

export const useRecommendedPackagesPaymentStatus = () => {
  const dispatch = useDispatch();

  const isRender = useSelector(selectIsRecommendedPackagePaymentStatusCheckInProgress);
  const payment = useSelector(selectPackagePayment);
  const isMobile = useSelector(selectIsMobileLayout);

  const handleRetryClick = useCallback(() => {
    if (payment && payment.paymentId && payment.provider) {
      dispatch(
        checkPaymentStatus({
          onChangePaymentStatus: processChangingCheckPaymentStatus(EPaymentStatusCheckType.Package),
          paymentId: payment.paymentId,
          provider: payment.provider,
        }),
      );
    }
  }, [dispatch, payment]);

  const status = defaultTo(payment?.status, undefined);

  return { isRender, isMobile, status, handleRetryClick };
};
